import { Layout } from "@/components/layout/Layout";
import { Seo } from "@/components/seo/Seo";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CTAGroup } from "@/components/CTAGroup";
import { BRAND } from "@/data/site";
import { breadcrumbSchema, orgSchema } from "@/lib/schema";

const BASE = "https://assets.cdn.filesafe.space/D8zHHsXQdNqiD1R03R0i/media";

const GALLERY_IMAGES = [
  { src: `${BASE}/6a7b2fc0602fa7d1821ecdd7.jpg`, alt: "Glossy natural wood-grain planks extending through an entryway toward a glass door" },
  { src: `${BASE}/6a7b2fc0fe4291bd1085d146.jpg`, alt: "Light wood-grain plank floor reflecting windows beside an open kitchen" },
  { src: `${BASE}/6a7b2fc0fe4291bd1085d14b.jpg`, alt: "Natural-toned plank flooring across an open living room with a fireplace" },
  { src: `${BASE}/6a7b2df2cbdeb8d57a3cc8e5.jpg`, alt: "Glossy honey-colored wood floor at a hallway corner with white baseboards" },
  { src: `${BASE}/6a7b2df2602fa7d182166e26.jpg`, alt: "Amber-toned wood flooring reflecting sunlight in a room beside a stair railing" },
  { src: `${BASE}/6a7b2df2602fa7d182166e01.jpg`, alt: "Honey-colored wood planks running along a narrow hallway through open doorways" },
  { src: `${BASE}/6a7b2df2e312fc3ba1a8f73a.jpg`, alt: "Glossy wood floor on an upstairs landing bordered by white stair balusters" },
  { src: `${BASE}/6a7b2d9d602fa7d182150179.jpg`, alt: "Light wood-grain plank flooring in an empty bedroom with a ceiling fan and two windows" },
  { src: `${BASE}/6a7b2d9dd32f9082b149e86b.jpg`, alt: "Polished natural wood floor reflecting two windows in an empty room" },
  { src: `${BASE}/6a7b2d6d4e002388f415210b.jpg`, alt: "Natural wood planks on a sunlit stair landing with a white railing" },
  { src: `${BASE}/6a7b2d6d0faacaac56d71d2d.jpg`, alt: "Varied golden wood-grain flooring across a spacious room with recessed lights" },
  { src: `${BASE}/6a7b2d05f47d149159759c05.jpg`, alt: "Glossy golden wood flooring in a blue-gray room viewed from a stair landing" },
  { src: `${BASE}/6a4e5c40ac2f159bb0624fbe.png`, alt: "Natural wood floor reflecting large windows in a living room with a white fireplace" },
  { src: `${BASE}/6a43ac5e8882e8f6e36308ae.jpeg`, alt: "Close view of polished wood-grain planks beside a kitchen and adjoining living area" },
  { src: `${BASE}/6a4e56fdac2f159bb060b902.png`, alt: "Light natural wood flooring with visible knots reflecting a bedroom window" },
  { src: `${BASE}/6a7b2f8072de28e6e8227892.jpg`, alt: "Dark brown wood-grain flooring in a narrow room with white closet doors" },
  { src: `${BASE}/6a7b2f804e002388f41c036d.jpg`, alt: "Dark polished wood floor reflecting windows in a dining room beside a kitchen" },
  { src: `${BASE}/6a7b2f8063f5cee4768e6102.jpg`, alt: "Dark wood flooring on a raised landing leading into a room with a radiator" },
];


const Gallery = () => {
  return (
    <Layout>
      <Seo
        title="Flooring Project Gallery | Residential & Commercial Floors in CT"
        description="Browse VRP Flooring's gallery of hardwood, vinyl, laminate and tile flooring projects across Danbury, Ridgefield, Bethel, Brookfield and Newtown, Connecticut."
        jsonLd={[orgSchema(), breadcrumbSchema([{ name: "Home", url: BRAND.website }, { name: "Gallery", url: `${BRAND.website}/gallery` }])]}
      />
      <section className="container-page py-12 md:py-16">
        <Breadcrumbs items={[{ name: "Home", href: "/" }, { name: "Gallery" }]} />
        <div className="mt-6 max-w-3xl">
          <p className="eyebrow mb-4 text-accentInk">Project Gallery</p>
          <h1 className="font-display text-4xl md:text-5xl font-bold mb-4">Residential and commercial flooring projects.</h1>
          <p className="text-muted-foreground text-lg">Real floors in real Connecticut homes and businesses — hardwood, vinyl, laminate, tile and full replacements.</p>
        </div>
      </section>
      <section className="container-page pb-20">
        <h2 className="sr-only">Flooring project photos</h2>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {GALLERY_IMAGES.map((it, i) => (
            <figure key={i} className="overflow-hidden rounded-lg group">
              <img src={it.src} alt={it.alt} loading="lazy" width={1280} height={960} className="w-full aspect-[4/3] object-cover transition-transform duration-700 group-hover:scale-105" />
            </figure>
          ))}
        </div>
      </section>
      <section className="bg-foreground text-background py-20">
        <div className="container-page text-center max-w-2xl">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">Ready to Transform Your Floors?</h2>
          <CTAGroup variant="onDark" className="justify-center" primaryLabel="Request a Free Estimate" />
        </div>
      </section>
    </Layout>
  );
};
export default Gallery;
